<!-- <mat-toolbar class="header" fxLayout="row">
    <a mat-button routerLink="/home" routerLinkActive="active" fxHide.xs>Home</a>
    <a mat-button routerLink="/emerg" routerLinkActive="active" fxHide.xs>My WarnMe Information</a>
    <a mat-button routerLink="/contact" routerLinkActive="active" fxHide.xs>Contact Us</a>
    <a mat-button routerLink="/faq" routerLinkActive="active" fxHide.xs>FAQs</a>
    <a *ngIf="isAdmin" mat-button routerLink="/admin" routerLinkActive="active" fxHide.xs>Admin View</a>
    <a mat-button routerLink="/logout" routerLinkActive="active" fxHide.xs>Log Out</a>
    <button mat-icon-button [matMenuTriggerFor]="dropMenu" fxHide fxShow.xs>
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #dropMenu="matMenu">
        <a mat-menu-item routerLink="/home" routerLinkActive="active">Home</a>
        <mat-divider></mat-divider>
        <a mat-menu-item routerLink="/emerg" routerLinkActive="active">My WarnMe Information</a>
        <mat-divider></mat-divider>
        <a mat-menu-item routerLink="/contact" routerLinkActive="active">Contact Us</a>
        <mat-divider></mat-divider>
        <a mat-menu-item routerLink="/faq" routerLinkActive="active">FAQs</a>
        <mat-divider></mat-divider>
        <a *ngIf="isAdmin" mat-menu-item routerLink="/admin" routerLinkActive="active">Admin View</a>
        <mat-divider></mat-divider>
        <a mat-menu-item routerLink="/logout" routerLinkActive="active">Log Out</a>
    </mat-menu>
</mat-toolbar> -->
<!-- <div class="input-group">
  <input type="text" class="form-control" placeholder="People or Departments" aria-label="People or Departments" aria-describedby="basic-addon2">
  <span class="input-group-addon" id="basic-addon2" routerLink="/admin">People</span>
  
</div> -->






   <div class="l-container">

   	<div class="page-title">

       		<div class="title-bar">{{pageTitle}}</div>         

   	</div>
    </div>
    

	<div class="l-container">

		<div class="l-content">

 			<div class="panel-pane box">  <!-- 0731-21 --large -->

                <form action="#" class="search-directory" [formGroup]="aFormGroup">
                    <div>
<!--ok                    
                        <input type="text" name="search" class="search-directory" formControlName="searchValue"
                            [(ngModel)]="searchValue" placeholder="Search">  search-popup__input  search-directory__submit
-->                                                          
                        <input valign="bottom" type="text" name="search" class="search-popup__input" (keypress)="keyPress($event)" formControlName="searchValue"
                            [(ngModel)]="searchValue" placeholder="Search">


                        <input valign="middle" type="submit" value="People" class="search-directory__submit"
                            [disabled]="aFormGroup.invalid" [routerLink]="['/peoples-list', searchValue]"> 

						<input valign="middle" type="submit" value="Departments" class="search-directory__submit"
						    [disabled]="aFormGroup.invalid" [routerLink]="['/deptSearch', searchValue]">

                    </div>
                </form>


			</div>   
    
		</div>
	</div>
	